import { ReactNode } from "react";
import useCoordinatorReport2, {
  CoordinatorReport2Context,
} from "./useCoordinatorReport2";

export interface CoordinatorReport2ProviderProps {
  children?: ReactNode;
}

const CoordinatorReport2Provider: React.FC<CoordinatorReport2ProviderProps> = ({
  children,
}) => {
  const context = useCoordinatorReport2();

  return (
    <CoordinatorReport2Context.Provider value={context}>
      {children}
    </CoordinatorReport2Context.Provider>
  );
};
export default CoordinatorReport2Provider;
